module.exports = __webpack_public_path__ + "img/add.98e88b20.svg";